import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Checkbox, Grid } from 'semantic-ui-react';
import { formValueSelector, reduxForm, reset } from 'redux-form';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Filter, Main } from 'Containers';
import { resetForm } from 'State/forms/actions';
import { PHYSICAL_FORM_NAME } from 'Common/FormEnum';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
  ReactTableWrapperColumnProperties,
} from 'Common/Constants';
import { PhysicalEnum } from 'Common/FieldEnum';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { PrintSortTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import * as GridPreferenceSelectors from 'State/gridPreference/selectors';
import {
  StatusOptionEnum,
  StatusEnum,
  SiteStatusEnum,
  GroupByEnum,
} from 'Common/Constants/Enumeration/PhysicalEnum';
import { createToast, errorToast, toastType } from 'Common/ToastHelper';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';
import { dateSortMethod } from 'Common/GridHelper';

import PhysicalList from '../../components/physicalList/PhysicalList';
import { actions } from '../../state/actions';
import { basicURL } from './../../helper';
import * as ListSelectors from '../../state/PhysicalList/selectors';

class PhysicalListContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,

    site: PropTypes.string,
    viewStatusOptionsValue: PropTypes.string,
    sortOptionsValue: PropTypes.number,
    groupByOptionsValue: PropTypes.number,
    fromDT: PropTypes.string,
    endDT: PropTypes.string,
    allTableStates: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,

    physicalListData: PropTypes.array.isRequired,
    printData: PropTypes.string.isRequired,
    gridPreferenceData: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    gridPreferenceLoading: PropTypes.bool.isRequired,
    gridPreferenceSubmitting: PropTypes.bool.isRequired,
    physicalListDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    preferenceJsonError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    gridPreferenceSubmitError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    deleteMsg: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    deleteErrorMsg: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    printLoadingError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    fromDateMax: PropTypes.object.isRequired,
    toDateMin: PropTypes.object.isRequired,
  };
  static defaultProps = {
    site: SiteStatusEnum.EMPTY,
    viewStatusOptionsValue: StatusEnum.OPEN,
    sortOptionsValue: PrintSortTypeEnum.ItemCode,
    groupByOptionsValue: GroupByEnum.NONE,
    fromDT: moment()
      .subtract(1, 'month')
      .format(DATE_FORMAT_FOR_UI),
    endDT: moment()
      .add(1, 'month')
      .format(DATE_FORMAT_FOR_UI),
    physicalListDataError: null,
    printError: null,
    preferenceJsonError: null,
    gridPreferenceSubmitError: null,
  };
  constructor(props) {
    super(props);
    this.reactTableRef = React.createRef();
    this.state = {
      showDeleteConfirm: false,
      showDeleteModel: false,
      selectedPhysical: null,
      activeIndexForFilter: 0,
      activeIndexForSort: 0,
      selectedPhysicals: [],
      columns: [
        {
          Header: currentRows => {
            const { selectedPhysicals } = this.state;
            const dataObjs = currentRows.data;
            let filteredData = [];
            let checkAllIds = [];
            _.forEach(dataObjs, obj => {
              const id = obj[PhysicalEnum.Id]
                ? obj[PhysicalEnum.Id]
                : obj._original[PhysicalEnum.Id];
              if (selectedPhysicals.indexOf(id) === -1) {
                filteredData.push(id);
              } else {
                checkAllIds.push(id);
              }
            });
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    dataObjs.length > 0 &&
                    checkAllIds.length === dataObjs.length
                  }
                  onChange={(e, { checked }) => {
                    if (checked) {
                      this.setState({
                        selectedPhysicals: [
                          ...this.state.selectedPhysicals,
                          ...filteredData,
                        ],
                      });
                    } else {
                      const copySelected = [...this.state.selectedPhysicals];
                      _.forEach(dataObjs, obj => {
                        const id = obj[PhysicalEnum.Id]
                          ? obj[PhysicalEnum.Id]
                          : obj._original[PhysicalEnum.Id];
                        const index = copySelected.indexOf(id);
                        if (index !== -1) {
                          copySelected.splice(index, 1);
                        }
                      });
                      this.setState({ selectedPhysicals: copySelected });
                    }
                  }}
                />
              </div>
            );
          },
          accessor: PhysicalEnum.Allowed,
          ...ReactTableWrapperColumnProperties,
          visibility: false,
          sortable: false,
          filterable: false,
          Cell: ({ original }) => {
            const { selectedPhysicals } = this.state;
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={selectedPhysicals.indexOf(original.Id) !== -1}
                  onChange={(e, { checked }) => {
                    this.checkCurrentRow(original, checked);
                  }}
                />
              </div>
            );
          },
        },
        {
          Header: 'Physical #',
          accessor: PhysicalEnum.Id,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Id',
          accessor: PhysicalEnum.SiteId,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Name',
          accessor: PhysicalEnum.SiteName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Physical Date',
          accessor: PhysicalEnum.PhysicalDT,
          sortMethod: dateSortMethod,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Status',
          accessor: PhysicalEnum.StatusDesc,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Comments',
          accessor: PhysicalEnum.Comments,
          ...ReactTableWrapperColumnProperties,
        },
        {
          resizable: false,
          width: 50,
          sortable: false,
          Cell: gridProps => {
            return GridContextMenu({
              gridProps,
              options: this.getMenuOptions(gridProps),
            });
          },
        },
      ],
    };
  }

  componentDidMount() {
    const {
      fromDT,
      endDT,
      site,
      initialValues,
      viewStatusOptionsValue,
    } = this.props;
    let statusOption = viewStatusOptionsValue
      ? viewStatusOptionsValue
      : initialValues[PhysicalEnum.ViewStatusOptions];

    let statusFilter =
      statusOption === PhysicalEnum.All
        ? ''
        : statusOption === PhysicalEnum.Open
          ? StatusOptionEnum.OPEN
          : StatusOptionEnum.CLOSED;

    const filtersOptions = {
      SiteId: site ? site : initialValues[PhysicalEnum.Site],
      DateFrom: fromDT
        ? moment(fromDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .subtract(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
      DateTo: endDT
        ? moment(endDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .add(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
      Status: statusFilter,
    };
    this.props.getPhysicalData(filtersOptions);
  }

  componentDidUpdate(prevProps) {
    const { printData, deleteMsg, clearPhysicalError } = this.props;
    if (deleteMsg) {
      createToast(toastType.success, deleteMsg.Title, deleteMsg.Message);
      clearPhysicalError();
    }
    if (
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'deleteErrorMsg') ||
      errorToast(this.props, prevProps, 'physicalListDataError')
    ) {
      clearPhysicalError();
    }
    if (printData && prevProps.printData !== this.props.printData) {
      ReportGeneration(printData, 'Physical report');
    }
  }

  componentWillUnmount() {
    this.props.clearPhysicalGridData();
    this.clearTableSavedState();
    toast.dismiss();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.PHYSICAL_LIST_CREATE_EDIT_TABLE,
      TableNamesEnum.PHYSICAL_LIST_TABLE,
    ]);
  };

  onAddClick = () => {
    this.props.history.push('/physical/0/0');
  };

  onDeleteClick = row => {
    const { physicalListData } = this.props;
    const selectedPhysicalIds = this.getFilteredSelectedPhysical();

    let physicalRow = selectedPhysicalIds.length ? 0 : row.Id;
    let selectedPhysicalData = [];
    selectedPhysicalIds.forEach(Id => {
      _.some(physicalListData, obj => {
        if (Id === obj.Id) {
          selectedPhysicalData.push(obj);
          return true;
        }
      });
    });
    let selectedStatus = _.filter(selectedPhysicalData, {
      StatusDesc: PhysicalEnum.Closed,
    });
    if (selectedStatus.length) {
      this.setState({
        showDeleteConfirm: !this.state.showDeleteConfirm,
      });
      return;
    }
    this.setState({
      selectedPhysical: physicalRow,
      showDeleteModel: !this.state.showDeleteModel,
    });
  };

  handleDeleteDialog = result => {
    if (result) {
      let physicalList = this.getFilteredSelectedPhysical();
      if (!physicalList.length) {
        physicalList[0] = this.state.selectedPhysical;
      }
      this.props.deletePhysical(physicalList).then(() => {
        const { fromDT, endDT, site, viewStatusOptionsValue } = this.props;
        this.getFilterData(fromDT, endDT, site, viewStatusOptionsValue);
      });
    }
    this.setState({ showDeleteModel: false });
  };

  closeDeleteOrderConfirm = () => {
    this.setState({
      showDeleteConfirm: !this.state.showDeleteConfirm,
    });
  };

  printPhysical = () => {
    const {
      physicalListData,
      fromDT,
      endDT,
      sortOptionsValue,
      groupByOptionsValue,
    } = this.props;
    const checkedPhysicalOrders = this.getFilteredSelectedPhysical();
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: physicalListData };
    if (
      checkedPhysicalOrders &&
      !checkedPhysicalOrders.length &&
      dataObjs.sortedData.length
    ) {
      checkedPhysicalOrders[0] = dataObjs.sortedData[0][PhysicalEnum.Id];
    }

    const DateFrom = moment(fromDT).format(DATE_FORMAT_FOR_SERVER);
    const DateTo = moment(endDT).format(DATE_FORMAT_FOR_SERVER);

    this.props.printPhysicalData({
      DateFrom,
      DateTo,
      SortType:
        sortOptionsValue === PrintSortTypeEnum.ItemDescription
          ? PrintSortTypeEnum.ItemDescription
          : PrintSortTypeEnum.ItemCode,
      TransactionIds: checkedPhysicalOrders,
      ChkGroupByAcctCat:
        groupByOptionsValue === GroupByEnum.ACCOUNTCATEGORY
          ? GroupByEnum.ACCOUNTCATEGORY
          : GroupByEnum.NONE,
    });
  };

  onEditClick = row => {
    this.props.history.push(`/physical/1/${row.Id}`);
  };

  clearFilters = () => {
    this.props.dispatch(reset(PHYSICAL_FORM_NAME));
    this.completeReset();
    const { initialValues } = this.props;
    this.getFilterData(
      initialValues[PhysicalEnum.FromDT],
      initialValues[PhysicalEnum.EndDT],
      initialValues[PhysicalEnum.Site],
      initialValues[PhysicalEnum.ViewStatusOptions]
    );
    this.setState({ selectedPhysicals: [] });
  };

  getMenuOptions = gridProps => {
    const { row } = gridProps;

    let menuOptions = [
      {
        icon: 'pencil',
        text:
          row && row.StatusDesc === StatusEnum.CLOSED ? 'View' : 'View/Edit',
        handler: this.onEditClick,
      },
      {
        icon: 'trash',
        text: 'Delete',
        className: 'danger',
        disabledWhen: row => row.Status === StatusOptionEnum.CLOSED,
        handler: this.onDeleteClick,
      },
    ];
    const selectedPhysicals = this.getFilteredSelectedPhysical();
    if (selectedPhysicals.length > 1) {
      menuOptions = [
        {
          icon: 'trash',
          text: 'Delete All',
          className: 'danger',
          disabledWhen: row => row.Status === StatusOptionEnum.CLOSED,
          handler: this.onDeleteClick,
        },
      ];
    }
    return menuOptions;
  };

  completeReset = () => {
    this.props.resetForm(PHYSICAL_FORM_NAME);
  };

  onChangeOfFromDT = (e, fromDT, prevFromDT) => {
    fromDT !== prevFromDT && this.selectFromDate(e, fromDT);
  };

  onChangeOfToDT = (e, endDate, prevEndDate) => {
    endDate !== prevEndDate && this.selectToDate(e, endDate);
  };

  selectFromDate = (e, fromDT) => {
    const { endDT, site, viewStatusOptionsValue } = this.props;
    this.props.setToDateMin(moment(fromDT, DATE_FORMAT_FOR_UI));
    this.getFilterData(fromDT, endDT, site, viewStatusOptionsValue);
    this.setState({ selectedPhysicals: [] });
  };

  selectToDate = (e, endDate) => {
    const { fromDT, site, viewStatusOptionsValue } = this.props;
    this.props.setFromDateMax(moment(endDate, DATE_FORMAT_FOR_UI));
    this.getFilterData(fromDT, endDate, site, viewStatusOptionsValue);
    this.setState({ selectedPhysicals: [] });
  };

  setSelectedSite = (newValue, preVal) => {
    const { fromDT, endDT, viewStatusOptionsValue } = this.props;
    newValue !== preVal &&
      this.getFilterData(fromDT, endDT, newValue, viewStatusOptionsValue);
  };

  setShowStatusOption = value => {
    const { fromDT, endDT, site } = this.props;
    this.getFilterData(fromDT, endDT, site, value);
  };

  getFilterData = (fromDT, endDT, site, value) => {
    if (fromDT && endDT) {
      let statusFilter =
        value === PhysicalEnum.All
          ? ''
          : value === PhysicalEnum.Open
            ? StatusOptionEnum.OPEN
            : StatusOptionEnum.CLOSED;
      const filtersOptions = {
        SiteId: site,
        DateFrom: moment(fromDT).format(DATE_FORMAT_FOR_SERVER),
        DateTo: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
        Status: statusFilter,
      };
      this.props.getPhysicalData(filtersOptions);
      this.setState({ selectedPhysicals: [] });
    }
  };

  handleClick = (e, titleProps) => {
    const { index, option } = titleProps;
    const { activeIndexForFilter, activeIndexForSort } = this.state;
    const newIndex = !option
      ? activeIndexForFilter === index
        ? -1
        : index
      : activeIndexForSort === index
        ? -1
        : index;
    !option
      ? this.setState({
          activeIndexForFilter: newIndex,
        })
      : this.setState({
          activeIndexForSort: newIndex,
        });
  };
  getFilteredSelectedPhysical = () => {
    const { physicalListData } = this.props;
    const { selectedPhysicals } = this.state;
    const checkedUsageOrders = [];
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: physicalListData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[PhysicalEnum.Id]
        ? obj[PhysicalEnum.Id]
        : obj._original[PhysicalEnum.Id];
      if (selectedPhysicals.indexOf(id) !== -1) {
        checkedUsageOrders.push(id);
      }
    });
    return checkedUsageOrders;
  };
  checkCurrentRow = (original, checked) => {
    let value = [...this.state.selectedPhysicals];
    checked
      ? value.indexOf(original[PhysicalEnum.Id]) === -1 &&
        value.push(original[PhysicalEnum.Id])
      : value.indexOf(original[PhysicalEnum.Id]) !== -1 &&
        value.splice(value.indexOf(original[PhysicalEnum.Id]), 1);

    this.setState({ selectedPhysicals: value });
  };
  render() {
    const { physicalListData, loading, fromDateMax, toDateMin } = this.props;
    const {
      columns,
      showDeleteConfirm,
      showDeleteModel,
      selectedPhysical,
      activeIndexForFilter,
      activeIndexForSort,
    } = this.state;

    return (
      <Fragment>
        <Filter title={'Physicals'}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12} />
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <Button
                  content="Create New"
                  type={'button'}
                  onClick={this.onAddClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <PhysicalList
            physicalListData={physicalListData}
            columns={columns}
            reactTableRef={this.reactTableRef}
            toDateMin={toDateMin}
            onChangeOfFromDT={this.onChangeOfFromDT}
            fromDateMax={fromDateMax}
            onChangeOfToDT={this.onChangeOfToDT}
            setSelectedSite={this.setSelectedSite}
            setShowStatusOption={this.setShowStatusOption}
            clearFilters={this.clearFilters}
            loading={loading}
            printPhysical={this.printPhysical}
            showDeleteConfirm={showDeleteConfirm}
            closeDeleteOrderConfirm={this.closeDeleteOrderConfirm}
            showDeleteModel={showDeleteModel}
            handleDeleteDialog={this.handleDeleteDialog}
            selectedPhysicalRecord={selectedPhysical}
            activeIndexForFilter={activeIndexForFilter}
            activeIndexForSort={activeIndexForSort}
            handleClick={this.handleClick}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(PHYSICAL_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(PHYSICAL_FORM_NAME)(state));

  return {
    site: selector(state, PhysicalEnum.Site),
    viewStatusOptionsValue: selector(state, PhysicalEnum.ViewStatusOptions),
    sortOptionsValue: selector(state, PhysicalEnum.SortOptions),
    groupByOptionsValue: selector(state, PhysicalEnum.GroupByOptions),
    fromDT: selector(state, PhysicalEnum.FromDT),
    endDT: selector(state, PhysicalEnum.EndDT),
    allTableStates: getTableStates(state),
    initialValues: {
      [PhysicalEnum.Site]: SiteStatusEnum.EMPTY,
      [PhysicalEnum.ViewStatusOptions]: StatusEnum.OPEN,
      [PhysicalEnum.SortOptions]: PrintSortTypeEnum.ItemCode,
      [PhysicalEnum.GroupByOptions]: GroupByEnum.NONE,
      [PhysicalEnum.FromDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [PhysicalEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
    },
    gridPreferenceData: GridPreferenceSelectors.getPreferenceJson(state),
    gridPreferenceLoading: GridPreferenceSelectors.getLoading(state),
    gridPreferenceSubmitting: GridPreferenceSelectors.getIsSubmitting(state),
    preferenceJsonError: GridPreferenceSelectors.getPreferenceJsonError(state),
    gridPreferenceSubmitError: GridPreferenceSelectors.getSubmitError(state),

    physicalListData: ListSelectors.getPhysicalListData(state),
    physicalListDataError: ListSelectors.getPhysicalListDataError(state),
    printData: ListSelectors.getPrintData(state),
    printError: ListSelectors.getPrintError(state),
    loading: ListSelectors.getLoading(state),
    deleteMsg: ListSelectors.getDeleteMsg(state),
    deleteErrorMsg: ListSelectors.getDeleteErrorMsg(state),
    printLoadingError: ListSelectors.getPrintLoadingError(state),
    fromDateMax: ListSelectors.getFromDateMax(state),
    toDateMin: ListSelectors.getToDateMin(state),
  };
};

PhysicalListContainer = reduxForm({
  destroyOnUnmount: false,
  form: PHYSICAL_FORM_NAME,
})(PhysicalListContainer);

const mapDispatchToProps = {
  ...actions,
  resetForm,
  setTableStates,
};

export const Physical = connect(
  mapStateToProps,
  mapDispatchToProps
)(PhysicalListContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/containers/physicalList/PhysicalListContainer.js